"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import Image from 'next/image';
import { motion } from "framer-motion";

// ✅ Array of image file names
const heroImages = ["3.webp","2.webp","1.webp","4.webp","5.webp","6.webp"];

const Hero = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: -40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className="w-full min-h-full md:min-h-screen flex items-start justify-center bg-radial-[at_50%_50%] from-[#F8F4EF] via-[#F5F2ED] to-[#E1D8C7] mt-xl"  // <-- Added padding-top here
    >
      <Swiper
        modules={[Autoplay, Pagination, EffectFade]}
        autoplay={{ delay: 2000, disableOnInteraction: false }}
        speed={1600}
        loop={true}
        pagination={{ clickable: true }}
        effect="fade"
        fadeEffect={{ crossFade: true }}
        className="w-full min-h-full md:min-h-screen aspect-[16/9] sm:aspect-[16/9] md:h-[calc(100vh-100px)] relative"
      >
        {heroImages.map((src, index) => (
          <SwiperSlide key={index} className="w-full h-full relative">
            <motion.div
              initial={{ scale: 1 }}
              animate={{ scale: 1.025 }}
              transition={{
                duration: 6,
                ease: "easeInOut",
                repeat: Infinity,
                repeatType: "reverse",
              }}
              className="absolute inset-0"
            >
              <Image
                src={`/${src}`}
                alt={`Hero Image ${index + 1}`}
                fill
                className="rounded-md shadow-lg object-cover"
                priority={index === 0}
                fetchPriority={index === 0 ? "high" : "low"}
              />
            </motion.div>
            <div className="absolute inset-0 bg-black/15 z-10" />
          </SwiperSlide>
        ))}
      </Swiper>
    </motion.section>
  );
};

export default Hero;




// // original code
// "use client";

// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Pagination, EffectFade } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/pagination";
// import "swiper/css/effect-fade";
// import Image from 'next/image';
// import { motion } from "framer-motion";

// // ✅ Array of image file names
// const heroImages = ["hero2.webp", "hero1.webp", "hero3.webp"];

// const Hero = () => {
//   return (
//     <motion.section
//       initial={{ opacity: 0, y: -40 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.3, ease: "easeOut" }}
//       className="w-full min-h-full flex items-start justify-center  bg-radial-[at_50%_50%] from-[#F8F4EF] via-[#F5F2ED] to-[#E1D8C7]  "
//     >
//       <Swiper
//         modules={[Autoplay, Pagination, EffectFade]}
//         autoplay={{ delay: 3000, disableOnInteraction: false }}
//         speed={1500}
//         loop={true}
//         pagination={{ clickable: true }}
//         effect="fade"
//         className="w-full   aspect-[16/9] sm:aspect-[16/9] md:h-[calc(100vh-100px)] relative"
//       >
       

// {heroImages.map((src, index) => (
//   <SwiperSlide key={index} className="w-full h-full">
//     <Image
//       src={`/${src}`}  // Correct the image path (add a leading slash for relative path)
//       alt={`Hero Image ${index + 1}`}
//       fill  // Use fill instead of layout="fill"
//         // To maintain the cover style
//       className="rounded-md shadow-lg"
//       priority={index === 0}
//        fetchPriority={index === 0 ? "high" : "low"}  // First image will have high priority
//     />
//   </SwiperSlide>
// ))}



//       </Swiper>
//     </motion.section>
//   );
// };

// export default Hero;
